import { Typography, theme } from "antd";
import { DefaultButton } from "components/Shared/DefaultButton";
import { useIntl } from "react-intl";

type Props = {
  season: any;
};

export const FixturesButton = ({ season }: Props) => {
  const { formatMessage } = useIntl();
  const { useToken } = theme;
  const { token } = useToken();

  return (
    <DefaultButton
      type="text"
      icon={
        season?.containsFixtureTasksInRejectedStatus ? (
          <i style={{ color: "red" }} className="fa-solid fa-circle-exclamation" />
        ) : null
      }
    >
      <Typography.Text strong style={{ color: token.colorPrimary }} className="text-upper">
        {formatMessage({ id: "button.fixtures" })}
      </Typography.Text>
    </DefaultButton>
  );
};
